import React, { useState, useMemo } from 'react';
import { Row, Col, Form, FormGroup, Button } from 'reactstrap';
import Moment from 'moment';
import DatePicker from 'react-datepicker';

const ConversionRateRow = ({
  conversionRate,
  removeConversionRate,
  setEndDateForConversionRate,
  selectedCategory,
}) => {
  const [endDate, setEndDate] = useState(null);

  const todayDate = useMemo(() => Moment(), []);
  const startDate = useMemo(
    () => Moment(conversionRate.startDate),
    [conversionRate.startDate],
  );
  const showDeleteButton = useMemo(
    () => startDate.isAfter(todayDate),
    [startDate, todayDate],
  );

  const handleEndDateChange = (date) => {
    setEndDate(date);
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (endDate) {
      setEndDateForConversionRate(
        conversionRate.id,
        Moment(endDate).format('DD-MMM-YYYY'),
      );
    }
  };

  const getStartDateRow = () => {
    if (selectedCategory === 'DEFAULT') return '';
    return (
      <Row>
        <Form className='form-inline' onSubmit={handleFormSubmit}>
          <Col>
            <FormGroup className='me-sm-2 mb-sm-0'>
              <DatePicker
                id='startDate'
                name='startDate'
                required
                selected={endDate}
                dateFormat='DD-MMM-YYYY'
                onChange={handleEndDateChange}
                locale='en-au'
              />
            </FormGroup>
          </Col>
          <Col>
            <Button color='primary' name='btnAdd' id='btnAdd' type='submit'>
              Save
            </Button>
          </Col>
        </Form>
      </Row>
    );
  };

  if (!conversionRate) return null;

  const endDateRow = getStartDateRow();

  return (
    <div>
      <Row className='campaign-row'>
        <Col md='4' className='white-border'>
          {Moment(conversionRate.startDate).format('DD MMM YYYY')}
        </Col>
        <Col md='4' className='white-border'>
          {conversionRate.endDate == null
            ? endDateRow
            : Moment(conversionRate.endDate).format('DD MMM YYYY')}
        </Col>
        <Col md='2' className='white-border float-right'>
          {Number(conversionRate.baseMultiplier).toFixed(6)}
        </Col>
        <Col md='2' className='white-border'>
          {showDeleteButton && (
            <button
              onClick={() =>
                removeConversionRate(conversionRate, conversionRate.id)
              }
              size='sm'
              className='btn btn-link'
            >
              Remove
            </button>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default ConversionRateRow;
